import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persist'
import { useGlobalStore } from "./store";
import { Data } from "./types/store";

const pinia = createPinia();
pinia.use(piniaPersist);
const app = createApp({
    template: `
      <div id="store" style="position: absolute"></div>`
});
app.use(pinia);
app.mount("#store");

const store = useGlobalStore();

export const token: Data = {
    get: () => store.token,
    set: (value: string) => store.setToken(value)
}

export const businessId: Data = {
    get: () => store.businessId,
    set: (value: string) => store.setBusinessId(value)
}

export const business: Data = {
    get: () => store.business,
    set: (value: any) => store.setBusiness(value)
}

export const businesses: Data = {
    get: () => store.businesses,
    set: (value: any[]) => store.setBusinesses(value)
}

export const userLoggedIn: Data = {
    get: () => store.userLoggedIn,
    set: (value: boolean) => store.setUserLoggedIn(value)
}

export const userInfo: Data = {
    get: () => store.userInfo,
    set: (value: any) => store.setUserInfo(value)
}

export const notifications: Data = {
    get: () => store.notifications,
    set: (value: any[]) => store.setNotifications(value)
}

export const listener: Data = {
    get: () => store.listener,
    set: (value: any) => store.setListener(value)
}

export const ref: Data = {
    get: () => store.ref,
    set: (value: any) => store.setRef(value)
}

export const redirectionId: Data = {
    get: () => store.redirectionId,
    set: (value: any) => store.setRedirectionId(value)
}

export const isPaymentLink: Data = {
    get: () => store.isPaymentLink,
    set: (value: boolean) => store.setIsPaymentLink(value)
}

export const paymentLinkUrl: Data = {
    get: () => store.paymentLinkUrl,
    set: (value: string) => store.setPaymentLinkUrl(value)
}

export const reset = () => store.reset();

export const benefitAssignation: Data = {
    get: () => store.benefit_assignation,
    set: (value: string) => store.setBenefitAssignation(value)
}

export const setLoggedInDataWithToken = (token: string) => store.setLoggedInDataWithToken(token);

export default pinia;